import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { useNavigate } from 'react-router-dom';
import DefaultButton from 'components/button/DefaultButton';

import { ReactComponent as Logo } from 'asserts/icons/3D_Logo.svg';
import { ReactComponent as IconArrowRight } from 'asserts/icons/ic_arrow_right_modal.svg';

const Error = () => {
  const navigate = useNavigate();

  const handleClickMoveMainPage = () => {
    navigate('/');
  };

  return (
    <Wrappaer>
      <ImageWrapper>
        <Logo />
        <ContentsWrapper>
          <Title>403 Forbidden Error</Title>
          <p>
            불편을 드려 죄송합니다. 요청하신 서비스가 일시적인 오류로 정상 처리되지 않았습니다. 잠시
            후 다시 시도해 주시기 바랍니다.
          </p>
          <p>
            The server encountered a temporary error and could not complete your request. Please try
            again in 30 seconds.
          </p>
        </ContentsWrapper>

        <DefaultButton
          onClick={handleClickMoveMainPage}
          text="홈으로 가기"
          rightIcon={<IconArrowRight />}
        />
      </ImageWrapper>
    </Wrappaer>
  );
};

export default Error;

const Wrappaer = styled.div`
  position: relative;
  height: 100vh;
  background: ${color.blue50};
`;

const Title = styled.h2`
  color: ${color.black2};
  ${font.h1_bold};
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    color: ${color.opacityBlack05};
    ${font.body_regular};
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 64px;

  button {
    display: inline-flex;
    width: 252px;
    height: 44px;
    justify-content: center;
    align-items: center;
    gap: 12px;
    border-radius: 24px;
    border: 1px solid ${color.black2};
  }
`;
